import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const TestFailed = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="m5.724 6.667.943-.943L8 7.057l1.333-1.333.943.943L8.943 8l1.333 1.333-.943.943L8 8.943l-1.333 1.333-.943-.943L7.057 8 5.724 6.667Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="m14.041 6.49-4.53-4.531a2.136 2.136 0 0 0-3.021 0l-4.531 4.53a2.136 2.136 0 0 0 0 3.021l4.53 4.531a2.136 2.136 0 0 0 3.021 0l4.531-4.53a2.136 2.136 0 0 0 0-3.021ZM7.433 2.902a.803.803 0 0 1 1.135 0l4.53 4.53a.803.803 0 0 1 0 1.136l-4.53 4.53a.803.803 0 0 1-1.135 0l-4.531-4.53a.803.803 0 0 1 0-1.135l4.53-4.531Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default TestFailed;
